<template>
  <div class="particularSend" :class="DTList.length > 2 ? '' : 'ht'">
    <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template> 

<script>
import  DtList from '../common/DtList'
export default {
  created() {
    this.orderId = localStorage.getItem('orderId')
  },
  data() {
    return {
      orderId:'',
      DTList: []
    };
  },
  methods: {
    priceList(DTList){
      this.DTList = DTList
    }
  },
  components:{
    DtList
  }
};
</script>

<style scoped>
</style>